import { generateIcon, type userConsentType } from "utils";
import {
  BsCalendar2Date,
  BsCloudArrowDownFill,
  BsFileEarmarkCheckFill,
  BsFileEarmarkX,
} from "react-icons/bs";
import { useTranslations } from "next-intl";
import { formatInTimeZone } from "../../helpers/timeZone";

interface IMediaGalleryPictogramsProps {
  userConsent: userConsentType;
  showQrStatus: boolean;
  isNew: boolean;
  date: string;
  timeZone?: string;
}

export default function MediaGalleryPictograms({
  userConsent,
  showQrStatus,
  isNew,
  date,
  timeZone,
}: IMediaGalleryPictogramsProps) {
  const t = useTranslations();

  return (
    <div className="absolute inset-0 p-[4px] bg-white/10 flex flex-col pointer-events-none text-[11px]">
      {showQrStatus ? (
        <div className="flex justify-start p-1 gap-1 opacity-75">
          {userConsent?.opened ? (
            <p className="flex items-center bg-black/80 text-white py-[2px] px-[4px] text-[12px] font-medium rounded uppercase">
              QR
            </p>
          ) : null}

          {userConsent?.accepted ? (
            <p className="flex items-center bg-black/80 text-white px-[4px] text-[10px] font-medium rounded uppercase">
              {generateIcon(BsFileEarmarkCheckFill, "h-[16px] w-[16px]")}
            </p>
          ) : null}

          {userConsent?.rejected ? (
            <p className="flex items-center bg-black/80 text-white px-[4px] text-[10px] font-medium rounded uppercase">
              {generateIcon(BsFileEarmarkX, "h-[16px] w-[16px]")}
            </p>
          ) : null}

          {userConsent?.downloaded ? (
            <p className="flex items-center bg-black/80 text-white px-[4px] text-[10px] font-medium rounded uppercase">
              {generateIcon(BsCloudArrowDownFill, "h-[16px] w-[16px]")}
            </p>
          ) : null}
        </div>
      ) : null}
      <div className="flex items-center mt-auto">
        <p className="flex items-center bg-black/80 text-white py-[3px] px-[4px] font-medium rounded">
          {generateIcon(BsCalendar2Date, "h-[14px] w-[14px] mb-[1px] mr-1")}
          {formatInTimeZone(date, "YY.MM.DD HH:mm", timeZone)}
        </p>

        {isNew ? (
          <p className="flex items-center bg-black/80 text-white py-[3px] px-[4px] font-medium ml-auto rounded lowercase">
            {t("Gallery.new")}
          </p>
        ) : null}
      </div>
    </div>
  );
}
